<template>
  <div class="about">
    <img src="https://oss-yihuan-oppo-com.oss-cn-beijing.aliyuncs.com/www/pictures/banner.png" alt="" class="banner" v-show="isMaxScreen">
    <img src="https://oss-yihuan-oppo-com.oss-cn-beijing.aliyuncs.com/www/pictures/banner1.png" alt="" v-show="!isMaxScreen" class="banner1">
    <div v-if="isMaxScreen" class="about-content">
      <ul class="tab">
        <li v-for="(item, index) in tabList" :key="index" class="tab-item" @click="changeIndex(index, item)">
          <span :class="itemIndex === index ? 'active' : ''">{{item.name}}</span>
          <span class="activeLine" v-show="itemIndex === index"></span>
        </li>
      </ul>
      <div class="introduction" v-show="itemIndex === 0">
        <img src="../assets/image/about/dang.png" alt="">
        <span>当换科技，以3C数码产品的回收、处置、销售为核心业务，致力于加速电子产品可循环效率，推动二手市场健康发展。</span>
        <span>为提供更好的产品和服务，当换打造了多元的业务品牌，包括线下门店服务平台“当换以旧换新”、线上3C数码产品回收平台“小当回收”、二手3C产品B2B平台“小当竞拍”、二手3C产品B2C平台“小当严选”、二手优品品牌“小当优品”以及海外业务品牌“eSwop”，提供一站式二手3C产品服务。</span>
        <span>当换目前与OPPO、vivo、一加、realme、iQOO、步步高、小天才等多个品牌达成官方战略合作关系，拥有专业的数码产品质检团队以及数据技术处理团队，致力于以先进的技术和专业的服务为基础，进一步地完善回收、检测、服务等标准的制定，以期提高回收行业的检测水平以及服务标准，为用户提供真诚贴心、安全可靠、专业高效的服务。当换始终提倡新的环保生活方式，让闲置焕发活力，为社会和用户创造更多价值。 </span>
      </div>
      <ul class="brand-vision" v-show="itemIndex === 1">
        <li class="brand-item" v-for="(item, index) in brandVisionList" :key="index">
          <div class="title">{{item.name}}</div>
          <div class="item-desc">{{item.text}}</div>
          <img :src="item.image" :alt="item.name">
        </li>
      </ul>
    </div>
    <div v-else class="about-content">
      <p class="title">公司简介</p>
      <div class="introduction">
        <img src="../assets/image/about/dang.png" alt="">
        <span>当换科技，以3C数码产品的回收、处置、销售为核心业务，致力于加速电子产品可循环效率，推动二手市场健康发展。</span>
        <span>为提供更好的产品和服务，当换打造了多元的业务品牌，包括线下门店服务平台“当换以旧换新”、线上3C数码产品回收平台“小当回收”、二手3C产品B2B平台“小当竞拍”、二手3C产品B2C平台“小当严选”、二手优品品牌“小当优品”以及海外业务品牌“eSwop”，提供一站式二手3C产品服务。</span>
        <span>当换目前与OPPO、vivo、一加、realme、iQOO、步步高、小天才等多个品牌达成官方战略合作关系，拥有专业的数码产品质检团队以及数据技术处理团队，致力于以先进的技术和专业的服务为基础，进一步地完善回收、检测、服务等标准的制定，以期提高回收行业的检测水平以及服务标准，为用户提供真诚贴心、安全可靠、专业高效的服务。当换始终提倡新的环保生活方式，让闲置焕发活力，为社会和用户创造更多价值。</span>
      </div>
      <p class="title">品牌愿景</p>
      <ul class="brand-vision">
        <li class="brand-item" v-for="(item, index) in brandVisionList" :key="index">
          <img :src="item.image" :alt="item.name">
          <div class="title">{{item.name}}</div>
          <span class="text-content">{{item.text}}</span>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
  data () {
    return {
      tabList: [
        {
          name: '公司简介',
          url: '/home',
          type: 1
        },
        {
          name: '品牌愿景',
          url: 'https://xiaodanghuishou.danghuan.com/static/index.html#/?channelId=100010',
          type: 2
        }
      ],
      itemIndex: 0,
      brandVisionList: [
        {
          image: require('../assets/image/about/icon_position.png'),
          name: '定位',
          text: '一站式二手3C产品服务平台'
        },
        {
          image: require('../assets/image/about/icon_mission.png'),
          name: '使命',
          text: '加速电子产品可循环效率，推动二手市场健康发展'
          // text1: '推动二手市场健康发展'
        },
        {
          image: require('../assets/image/about/icon_vision.png'),
          name: '愿景',
          text: '成为全球领先的二手电子产品服务平台'
        },
        {
          image: require('../assets/image/about/icon_values.png'),
          name: '企业价值观',
          text: '本分 客户至上 结果导向'
        }

      ]
    }
  },
  computed: {
    ...mapState({
      isMaxScreen: state => {
        return state.isMaxScreen
      }
    })
  },
  methods: {
    changeIndex (index, item) {
      this.itemIndex = index
      // item.type === 1 ? this.$router.push(item.url) : window.open(item.url)
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
@media (max-width: 980px) {
  .about {
    background: #F2F5F8;
    .banner1 {
      width: 100%;
      height: 100%;
      padding: 0 24px;
      box-sizing: border-box;
    }
    .about-content {
      float: left;
      margin-top: -5px;
    }
    .title {
      margin: 55px 24px 22px 24px;
      font-size: 32px;
      line-height: 32px;
      font-weight: 550;
      color: #333;
      text-align: left;
    }
    .introduction {
      // height: 716px;
      border-radius: 20px;
      margin: 0px 24px;
      padding: 34px;
      box-sizing: border-box;
      background: #fff;
      box-sizing: border-box;
      position: relative;
      img {
        width: 509px;
        height: 495px;
        position: absolute;
        bottom: 0;
        right: 0;
      }
      span {
        display: block;
        font-size: 24px;
        color: #333;
        word-break: break-all;
        letter-spacing: 2px;
        line-height: 40px;
        text-align: left;
        margin-bottom: 24px;
        font-weight: normal;
      }
      span:last-child {
        margin-bottom: 0px;
      }
    }
    .brand-vision {
      margin: 0 24px 24px 24px;
      display: flex;
      flex-wrap: wrap;
      .brand-item {
        position: relative;
        background: #fff;
        box-sizing: border-box;
        margin-bottom: 24px;
        padding: 36px 0 0 24px;
        // padding-left: 24px;
        border-radius: 20px;
        width: 339px;
        height: 168px;
        display: flex;
        flex-direction: column;
        img {
          position: absolute;
          right: 0;
          bottom: 0;
          width: 100px;
          height: 140px;
        }
        .title {
          width: 100%;
          font-size: 28px;
          line-height: 36px;
          color: #282828;
          margin: 0 0 12px 0;
          font-weight: 500;
        }
        .text-content {
          width: 300px;
          line-height: 30px;
          text-align: left;
          box-sizing: border-box;
        }
        span {
          font-size: 24px;
          color: #282828;
          font-weight: 400;
        }
        &:nth-child(odd) {
          margin-right: 24px;
        }
      }
    }
  }
}
@media (min-width: 981px) {
  .about {
    .banner {
      width: 100%;
      height: 440PX;
    }
    .about-content {
      width: 1200PX;
      width: 100%;
      display: flex;
      flex-direction: column;
      align-items: center;

      line-height: 80PX;
      background: #F6F6F6;
    }
    .tab {
      width: 1200PX;
      // width: 100%;
      height: 98PX;
      margin: 0;
      padding: 0;
      display: flex;
      align-items: center;
      justify-content: center;
      .tab-item {
        width: 600PX;
        color: #333;
        list-style: none;
        cursor: pointer;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        position: relative;
        span {
          font-size: 24PX;
          line-height: 24PX;
          color: #333;
        }
        .activeLine {
          width: 30PX;
          height: 4PX;
          background: #FF9600;
          border-radius: 2PX;
          position: absolute;
          top: 38PX;
          left: 285PX;
        }
        .active {
          color: #FF9600!important;
          font-weight: 500;
        }
      }
    }
    .introduction {
      width: 1200PX;
      // height: 440PX;
      border-radius: 20PX;
      padding: 52PX 58PX 82PX 62PX;
      box-sizing: border-box;
      position: relative;
      background: white;
      margin-bottom: 36PX;
      img {
        width: 590PX;
        height: 460PX;
        position: absolute;
        right: 0;
        bottom: 0;
        z-index: 2;
      }
      span {
        display: block;
        margin: 0;
        padding: 0;
        font-size: 20PX;
        line-height: 32PX;
        color: #333;
        text-align: left;
        margin-bottom: 60PX;
        font-weight: normal;
        &:last-child {
        margin-bottom: 0;
        }
      }
    }
    .brand-vision {
      width: 1236PX;
      list-style: none;
      border-radius: 20PX;
      margin: 0;
      padding-top: 34PX;
      box-sizing: border-box;
      display: flex;
      flex-wrap: wrap;
      .brand-item {
        position: relative;
        background: white ;
        width: 540PX;
        height: 220PX;
        margin-bottom: 36PX;
        padding: 80PX 0 0 60PX;
        border-radius: 20PX;
        img {
          position: absolute;
          bottom: 0;
          right: 0;
          width: 168PX;
          height: 240PX;
        }
        .title {
          height: 70PX;
          text-align: left;
          color: #282828;
          font-size: 48PX;
          font-weight: 500;
          line-height: 70PX;
          color: #333;
        }
        .item-desc{
          width: 480PX;
          margin-top: 12PX;
          color: #282828;
          font-size: 24PX;
          text-align: left;
          font-weight: 400;
          line-height: 36PX; /* 150% */
          letter-spacing: 1px;
        }

      }
      .brand-item:nth-child(odd) {
        margin-right: 36PX;
      }
    }
  }
}
</style>
